<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="text-sm text-bold text-gray-700 mb-2"
    >
      {{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <select
      :id="name"
      v-model="value"
      :name="name"
      :disabled="disabled"
      :required="required"
      class="form-select"
    >
      <option value="" disabled selected>{{ disabledValueText }}</option>
      <template v-if="!keyValuePairs">
        <option v-for="value in values" :key="value.id" :value="value">
          {{ value[fieldName] ?? value }}
        </option>
      </template>
      <template v-else>
        <option v-for="(value, key) in values" :key="key" :value="key">
          {{ value }}
        </option>
      </template>
    </select>
    <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  keyValuePairs: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    required: false,
  },
  error: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: true,
  },
  values: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  fieldName: {
    type: String,
  },
  disabledValueText: {
    type: String,
    default: "Select a rate",
  },
});

const value = defineModel({ type: [Object, String], default: null });
</script>

<style></style>
